import { createBackgroundLoaderContext } from "contexts";
import { StudentTeacher } from "models";

export const StudentTeacherContext = createBackgroundLoaderContext<StudentTeacher>();
